<template>
  <div class="nodata">
    <img src="@/assets/zanwushuju-2@2x.png" height="177" width="177"/>
    <div class="nodatatext">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "NoData"
}
</script>

<style lang="scss" scoped>
  .nodata{
    width: 1200px;
    text-align: center;
    img{
      margin-top: 30px;
      margin-bottom: 10px;
      width: 100px;
      height: 100px;
    }
    .nodatatext{
      font-size: 16px;
      color:#666666;
      margin-bottom: 30px;
    }
  }
</style>
